import { Component, Input } from '@angular/core';
import { footerKey } from 'src/app/interfaces/images/nav-footer-collection.interface';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() footerImgs?: footerKey;
}
